<div class="app-shell container-fluid" [ngClass]="{'dark-mode': isDarkMode}">
  <p-toast position="center" [baseZIndex]="20000">
    <ng-template let-message pTemplate="message">
      <div class="toast-message">
        <div class="toast-summary" *ngIf="message.summary">{{ message.summary }}</div>
        <div class="toast-detail" [innerHTML]="message.detail"></div>
      </div>
    </ng-template>
  </p-toast>
  <nav class="top-navbar">
    <div class="region-dropdown">

      <button class="region-trigger" type="button" (click)="toggleMenu($event)">

        <span class="location-icon"><svg viewBox="0 0 640 640" fill="currentColor" width="24" height="24" class="size-[20px] text-primary-blue"><path d="M160 252.6C160 166.6 231.1 96 320 96C408.9 96 480 166.6 480 252.6C480 302.9 454.1 362 418.6 418.2C384.6 472 344.6 518.7 320 545.6C295.4 518.7 255.4 471.9 221.4 418.2C185.9 362 160 302.9 160 252.6zM320 64C214 64 128 148.4 128 252.6C128 371.9 248.2 514.9 298.4 569.4C310.2 582.2 329.8 582.2 341.6 569.4C391.8 514.9 512 371.9 512 252.6C512 148.4 426 64 320 64zM368 256C368 282.5 346.5 304 320 304C293.5 304 272 282.5 272 256C272 229.5 293.5 208 320 208C346.5 208 368 229.5 368 256zM320 176C275.8 176 240 211.8 240 256C240 300.2 275.8 336 320 336C364.2 336 400 300.2 400 256C400 211.8 364.2 176 320 176z"></path></svg></span>
        <span>{{ selectedRegion }}</span>
        <span class="arrow" [class.rotate]="isMenuOpen">
          <svg viewBox="0 0 640 640" fill="currentColor" width="12" height="12" class="text-primary-blue"><path d="M331.3 475.3C325.1 481.5 314.9 481.5 308.7 475.3L100.7 267.3C94.5 261.1 94.5 250.9 100.7 244.7C106.9 238.5 117.1 238.5 123.3 244.7L320 441.4L516.7 244.7C522.9 238.5 533.1 238.5 539.3 244.7C545.5 250.9 545.5 261.1 539.3 267.3L331.3 475.3z"></path></svg>
        </span>

      </button>

      <div class="region-menu" *ngIf="isMenuOpen">

        <button *ngFor="let region of regions" type="button" class="region-option"
          [class.selected]="selectedRegion === region" (click)="selectRegion(region)">

          <span>
            {{ selectedRegion === region ? '✔' : '○' }}
          </span>

          <span>{{ region }}</span>

        </button>

      </div>

    </div>
  </nav>
  <!-- Header Component -->
  <app-header></app-header>

  <!-- Main Content Wrapper -->
  <main class="page-content" [ngClass]="{'dark-mode': isDarkMode}">
    <div class="main-content enroll-content" [ngClass]="{'dark-mode': isDarkMode}">

      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- Footer Component -->
  <app-footer></app-footer>
</div>